/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_IllustrationInputs */

const en_of_landing_illustration = /** @type {(inputs: Of_Landing_IllustrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virtual office illustration: team area, meeting room, focus area, and social space.`)
};

const id_of_landing_illustration = /** @type {(inputs: Of_Landing_IllustrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustrasi kantor virtual: area tim, ruang rapat, area fokus, dan ruang santai.`)
};

/**
* | output |
* | --- |
* | "Virtual office illustration: team area, meeting room, focus area, and social space." |
*
* @param {Of_Landing_IllustrationInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_illustration = /** @type {((inputs?: Of_Landing_IllustrationInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_IllustrationInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_illustration(inputs)
	return en_of_landing_illustration(inputs)
});